export const FIND_OPEN_PROCESS_STATEMENTS_SUCCESS = 'FIND_OPEN_PROCESS_STATEMENTS_SUCCESS';

export const findOpenProcessStatementsSuccess = ({ processStatements, request, response }) => ({
    type: FIND_OPEN_PROCESS_STATEMENTS_SUCCESS,
    payload: { processStatements },
    meta: {
        request,
        response,
    }
});
